import supabase from "../config/supabase";

const asObject = (data) => {
  if (!data) return null;
  if (typeof data === "string") {
    try {
      return JSON.parse(data);
    } catch {
      return null;
    }
  }
  return data;
};

/**
 * Directory checks: one-tap "still going?" on a stale service listing.
 *
 * Eligibility, points, flags and notifications are decided server-side.
 * The client only asks whether to show the row, and submits the tap.
 */
const listingChecksApi = {
  /**
   * Should this member see the check row on this listing?
   * @param {string} serviceId
   * @returns {Promise<{success: boolean, show?: boolean, error?: string}>}
   */
  async prompt(serviceId) {
    if (!serviceId) return { success: true, show: false };

    const { data, error } = await supabase.rpc("listing_check_prompt", {
      p_service_id: serviceId,
    });
    if (error) return { success: false, error: error.message };

    const parsed = asObject(data);
    return { success: true, show: Boolean(parsed?.show) };
  },

  /**
   * Record a check.
   * @param {string} serviceId
   * @param {'confirmed'|'closed'|'wrong_number'} outcome
   * @returns {Promise<{success: boolean, points?: number, error?: string}>}
   */
  async submit(serviceId, outcome) {
    const {
      data: { user },
    } = await supabase.auth.getUser();
    if (!user) return { success: false, error: "Please sign in to do that." };

    const { data, error } = await supabase.rpc("submit_listing_check", {
      p_service_id: serviceId,
      p_outcome: outcome,
    });
    if (error) return { success: false, error: error.message };

    const parsed = asObject(data);
    if (!parsed?.ok) {
      return { success: false, error: parsed?.error || "Could not save that." };
    }
    return { success: true, points: parsed.points };
  },
};

export default listingChecksApi;
